<template>
  <v-container fluid greybgright>
  <v-toolbar app color="white" id="topbar" class="hidden-sm-and-down">
   <v-toolbar-title v-if="branddata.brand"><img class="logo" v-bind:src="'https://manage.msa.airportdirecttravel.com/uploads/'+branddata.brand.brand_logo"></v-toolbar-title>
      <v-toolbar-items >
        <v-btn
          flat
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path">
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>
</v-toolbar>
	  <v-expansion-panel class="hidden-md-and-up">
    <v-expansion-panel-content>
      <div slot="header" v-if="branddata.brand"><img class="logo" v-bind:src="'https://manage.msa.airportdirecttravel.com/uploads/'+branddata.brand.brand_logo"></div>
	  <div slot="header" v-else>
	  Menu
	  </div>
	   <v-btn
          flat left
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path">
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
	</v-expansion-panel-content>
  </v-expansion-panel>
<v-container grid-list-md >
    <v-layout row wrap>
		<v-flex md9  mt-2 mb-5>
		
        <h2 class="pagetitle">Passport Details</h2>
		<div v-if="this.airportapis.success===1">
		<v-layout row wrap >
		
		<v-flex xs12  mt-2 mr-1 pb-5 pt-2 pl-1 pr-1 >
				<v-flex>
		  <v-alert type="error" dismissible v-model="alert">
			{{ error }}
		  </v-alert>
		</v-flex>
		<v-flex v-if="datepiddis[1] !== null"><v-alert :value="true" type="error" >It seems that you have already submitted your passport information. If you have any questions or need to make changes, please <a class="whlink" href="/support">contact support</a></v-alert></v-flex>
		<form class="passportform"  @submit.prevent="SubmitAPIS">
		<v-text-field  v-if="bookingnumber" label="Booking Reference" box   v-model="bookingnumber" readonly ></v-text-field>
		<div v-if="typeof bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.length!=='undefined'">
		<v-layout row wrap pt-2 pl-2 v-for="(item, index) in bookingdata.Flights.Flight.FlightPassengers.FlightPassenger">
		<v-flex xs12   >
		<h3 mb-1>Passenger {{index+1}}</h3>
		</v-flex>
		
  <v-flex md6><v-text-field label="Title" box :value="item.Title" disabled></v-text-field> </v-flex>
  <v-flex md6><v-text-field label="First Name" box :value="item.FirstName" disabled ></v-text-field></v-flex>

  <v-flex md6 v-if="typeof item.MiddleName === 'string'"><v-text-field label="Middle Name" :value="item.LastName" box disabled></v-text-field></v-flex> <v-flex md6 v-else><v-text-field label="Middle Name" box disabled></v-text-field></v-flex>
  
  <v-flex md6><v-text-field label="Last Name" box  :value="item.LastName" disabled></v-text-field></v-flex>
 
   <v-flex md6>
  <v-text-field label="Date Of Birth" box  v-model="DateOfBirth[index+1]" disabled></v-text-field>
   </v-flex>
 <v-flex md6 >
  <v-menu  v-if="datepiddis[1] === null" ref="menu2" :close-on-content-click="false" v-model="DateOfBirthmenu[index+1]" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px" ><v-text-field  slot="activator" v-model="DateOfBirthdate[index+1]" label="Change Date Of Birth*" readonly required></v-text-field><v-date-picker  v-model="DateOfBirth_ch[index+1]" no-title @input="$refs.menu2[index].save(DateOfBirth_ch[index+1])"></v-date-picker></v-menu>
  </v-flex> 
  
  <v-flex md6 v-if="datepiddis[1] === null"><v-select :items="genderitems" v-model="gender[index+1]" box label="Gender*" required></v-select> </v-flex>
  <v-flex md6 v-else><v-select :items="genderitems" v-model="gender[index+1]" box label="Gender-" disabled></v-select> </v-flex>
	  
  <v-flex md6 v-if="datepiddis[1] === null"><v-autocomplete :items="nationalityitems" box return-object label="Nationality*" v-model="nationality[index+1]" required></v-autocomplete></v-flex>
  <v-flex md6 v-else><v-select :items="nationalityitems" box label="Nationality*" v-model="nationality[index+1]" disabled></v-select></v-flex>
  
  <v-flex md6 v-if="datepiddis[1] === null"><v-text-field label="Passport Number*" box v-model="passport_number[index+1]" required></v-text-field></v-flex>  
  <v-flex md6 v-else><v-text-field label="Passport Number*" box v-model="passport_number[index+1]" disabled></v-text-field></v-flex>  

 <v-flex md6 v-if="datepiddis[1] === null">
 
  <v-menu  ref="menu3" :close-on-content-click="false" v-model="menupid[index+1]" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px" ><v-text-field slot="activator"  v-model="datepidd[index+1]" label="Passport Issue Date*" readonly box required ></v-text-field><v-date-picker v-model="datepid[index+1]" no-title @input="$refs.menu3[index].save(datepid[index+1])"></v-date-picker></v-menu>
  </v-flex>
  <v-flex md6 v-else><v-text-field label="Passport Issue Date" box  :value="datepiddis[index+1]" disabled></v-text-field></v-flex>
  
  <v-flex md6 v-if="datepiddis[1] === null"><v-autocomplete :items="passportissueplaceitems" box return-object label="Passport Issue Place*" v-model="passport_issue_place[index+1]" required></v-autocomplete></v-flex>
  <v-flex md6 v-else><v-select :items="passportissueplaceitems" box label="Passport Issue Place*" v-model="passport_issue_place[1]" disabled></v-select></v-flex>

 <v-flex md6 v-if="datepiddis[1] === null">

   
   <v-menu ref="menu4" :close-on-content-click="false" v-model="menuped[index+1]" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px" ><v-text-field slot="activator"  v-model="datepedd[index+1]" label="Passport Expiry Date*"  readonly box required ></v-text-field><v-date-picker v-model="dateped[index+1]" no-title @input="$refs.menu4[index].save(dateped[index+1])"></v-date-picker></v-menu>
   
  </v-flex>
  
 <v-flex md6 v-else><v-text-field label="Passport Expiry Date" box  :value="datepeddis[index+1]" disabled></v-text-field></v-flex>

		
		</v-layout>
		</div>
		<div v-else>
		
		<v-layout row wrap pt-2 pl-2 >
				<v-flex xs12   >
		<h3 mb-1>Passenger 1</h3>
		</v-flex>
		
  <v-flex md6><v-text-field label="Title" box :value="bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.Title" disabled></v-text-field> </v-flex>
  <v-flex md6><v-text-field label="First Name" box :value="bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.FirstName" disabled ></v-text-field></v-flex>
  
 <v-flex md6 v-if="typeof bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.MiddleName === 'string'"><v-text-field label="Middle Name" :value="bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.LastName" box disabled></v-text-field></v-flex> <v-flex md6 v-else><v-text-field label="Middle Name" box disabled></v-text-field></v-flex>
  
  <v-flex md6><v-text-field label="Last Name" box  :value="bookingdata.Flights.Flight.FlightPassengers.FlightPassenger.LastName" disabled></v-text-field></v-flex>
  
  <v-flex md6>
  <v-text-field label="Date Of Birth" box  v-model="DateOfBirth[1]" disabled></v-text-field>
   </v-flex>
  <v-flex md6>
  <v-menu v-if="datepiddis[1] === null" ref="menu2" :close-on-content-click="false" v-model="DateOfBirthmenu[1]" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px" ><v-text-field slot="activator" v-model="DateOfBirthdate[1]" label="Change Date Of Birth*" readonly required ></v-text-field><v-date-picker v-model="DateOfBirth_ch[1]" no-title @input="$refs.menu2[0].save(DateOfBirth_ch[1])"></v-date-picker></v-menu>
  
  </v-flex>
 
  <v-flex md6 v-if="datepiddis[1] === null"><v-select :items="genderitems" v-model="gender[1]" box label="Gender-" required></v-select> </v-flex>
  <v-flex md6 v-else><v-select :items="genderitems" v-model="gender[1]" box label="Gender-" disabled></v-select> </v-flex>
	  
  <v-flex md6 v-if="datepiddis[1] === null"><v-autocomplete :items="nationalityitems" box label="Nationality*" return-object v-model="nationality[1]" required></v-autocomplete></v-flex>
  <v-flex md6 v-else><v-select :items="nationalityitems" box label="Nationality*" v-model="nationality[1]" disabled></v-select></v-flex>

  <v-flex md6 v-if="datepiddis[1] === null"><v-text-field label="Passport Number*" box v-model="passport_number[1]" required></v-text-field></v-flex>  
  <v-flex md6 v-else><v-text-field label="Passport Number*" box v-model="passport_number[1]" disabled></v-text-field></v-flex>  

  <v-flex md6 v-if="datepiddis[1] === null">
  <v-menu   ref="menu3" :close-on-content-click="false" v-model="menupid[1]" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px" ><v-text-field slot="activator" v-model="datepidd[1]"  label="Passport Issue Date*" readonly box required ></v-text-field><v-date-picker v-model="datepid[1]" no-title @input="$refs.menu3[0].save(datepid[1])"></v-date-picker></v-menu>
  </v-flex>
  <v-flex md6 v-else><v-text-field label="Passport Issue Date" box  :value="datepiddis[1]" disabled></v-text-field></v-flex>
  
  <v-flex md6 v-if="datepiddis[1] === null" ><v-autocomplete :items="passportissueplaceitems" box return-object  label="Passport Issue Place*" v-model="passport_issue_place[1]" required></v-autocomplete></v-flex> 
  <v-flex md6 v-else><v-select :items="passportissueplaceitems" box label="Passport Issue Place*" v-model="passport_issue_place[1]" disabled></v-select></v-flex> 

 <v-flex md6 v-if="datepiddis[1] === null">
   <v-menu ref="menu4" :close-on-content-click="false" v-model="menuped[1]" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px" ><v-text-field slot="activator" v-model="datepedd[1]"  label="Passport Expiry Date*"  readonly box required ></v-text-field><v-date-picker v-model="dateped[1]" no-title @input="$refs.menu4[0].save(dateped[1])"></v-date-picker></v-menu>
  </v-flex>
  <v-flex md6 v-else><v-text-field label="Passport Expiry Date" box  :value="datepeddis[1]" disabled></v-text-field></v-flex>
		
		</v-layout>
		</div>
		<v-layout row wrap pt-2 pl-2 >
		
		
  
 
		<div v-if="datepiddis[1] === null">
		<v-btn type="submit"  color="mybuttoncolorsm">Submit Passport Information</v-btn>
		</div>
		<div v-else>
		<p>It seems that you have already submitted your passport information. If you have any questions or need to make changes, please <a href="/support">contact support</a></p>
		</div>
		</v-layout>
		
		</form>
		</v-flex>
		</v-layout>
		</div>
		
		<div v-else>
		<div v-if="this.airportapis.success===0">
		<v-flex xs12  mt-2 mb-5 mr-2>
		<v-alert :value="true" type="info" >You only need to add your passport details, if you are travelling overseas.</v-alert>
		</v-flex>
		</div>
		</div>
		

		
		</v-flex>
		<v-flex md3  mt-2 mb-5 borderleftright >

		<v-flex xs12  mt-2 mb-5>
		<h3>Confirmation Email</h3>
		<p>Send yourself another copy of your confirmation email. If you do not receive a copy via email, please contact support.</p>
		<v-btn color="mybuttoncolor" @click="ResendConfirmation">Resend Confirmation</v-btn>
		</v-flex>
		
		<v-flex xs12  mt-5 mb-5 greybgright>
		<h3>Passport Details</h3>
		<p>If you are travelling overseas please add your passport details prior to travelling.</p>
		<v-btn  color="mybuttoncolor" to="/passport">Add Details</v-btn>
		</v-flex>		
		
		<v-flex xs12  mt-5 mb-5>
		<h3>Read Our FAQ</h3>
		<p>For help and support with any of your pre-travel queries browse our frequently asked questions.</p>
		<v-btn v-if="branddata.brand" color="mybuttoncolor"  target="_blank" :href="this.branddata.brand.Brand_FAQ_Link">Read FAQs</v-btn>
		</v-flex>		
		
		<v-flex xs12  mt-5 mb-5 greybgright>
		<h3>Contact Support</h3>
		<p>If you have any queries regarding your booking, please contact our support team.</p>
		<v-btn  color="mybuttoncolor" to="/support">Contact Support</v-btn>
		</v-flex>
		
		
		</v-flex>
		
     
    </v-layout>
	<v-dialog v-model="passupport" max-width="290">
      <v-card>
        <v-card-title class="headline">Success</v-card-title>
        <v-card-text>Thank you for submitting your passport information.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="passupport = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>		
	
	<v-dialog v-model="confsupport" max-width="290">
      <v-card>
        <v-card-title class="headline">Success</v-card-title>
        <v-card-text>Confirmation Email Resent.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="confsupport = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>	
	<v-footer class="pa-3" color="grey" fixed>
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
  </v-container>
  </v-container>

</template>
   
  
   

<script>
const axios = require('axios');

export default {

    data () {
      return {
        menuItems: [
          { title: 'Dashboard', path: '/dashboard' },
          { title: 'Manage My Booking', path: '/mybooking' },
          { title: 'Add Passport Details', path: '/passport' },
          { title: 'Contact Support', path: '/support' },
          { title: 'Logout', path: '/logout' }
        ],
		valid: false,
		menu2: [],
		menu3: [],
		menu4: [],
		menupid: [],
		DateOfBirthmenu: [],
		menuped: [],			
		dateped: [],		
		datepid: [],		
		DateOfBirth_ch: [],		
		modalModel:false,
		nationalityitems: ['British','Afghan','Albanian','Algerian','Andorran','Angolan','Argentinian','Armenian','Australian','Austrian','Azerbaijani','Bahamian','Bahraini','Bangladeshi','Barbadian','Belorussian','Belgian','Belizian','Beninese','Bhutanese','Bolivian','Bosnian','Botswanan','Brazilian','Bruneian','Bulgarian','Burkinese','Burmese','Burundian','Cambodian','Cameroonian','Canadian','Cape Verdean','Chadian','Chilean','Chinese','Colombian','Congolese','Costa Rican','Croatian','Cuban','Cypriot','Czech','Danish','Djiboutian','Dominican','Ecuadorean','Egyptian','Salvadorean','Eritrean','Estonian','Ethiopian','Fijian','Finnish','French','Gabonese','Gambian','Georgian','German','Ghanaian','Greek','Grenadian','Guatemalan','Guinean','Guyanese','Haitian','Dutch','Honduran','Hungarian','Icelandic','Indian','Indonesian','Iranian','Iraqi','Irish','Israeli','Italian','Jamaican','Japanese','Jordanian','Kazakh','Kenyan','Kuwaiti','Laotian','Latvian','Lebanese','Liberian','Libyan','Lithuanian','Macedonian','Madagascan','Malawian','Malaysian','Maldivian','Malian','Maltese','Mauritanian','Mauritian','Mexican','Moldovan','Monacan','Mongolian','Montenegrin','Moroccan','Mozambican','Namibian','Nepalese','New Zealand','Nicaraguan','Nigerien','North Korean','Norwegian','Omani','Pakistani','Panamanian','Papua New Guinean','Paraguayan','Peruvian','Philippine','Polish','Portuguese','Qatari','Romanian','Russian','Rwandan','Saudi Arabian','Senegalese','Serbian','Seychellois','Sierra Leonian','Singaporean','Slovak','Slovenian','Somali','South African','SouthKorean','Spanish','Sri Lankan','Sudanese','Surinamese','Swazi','Swedish','Swiss','Syrian','Taiwanese','Tadjik','Tanzanian','Thai','Togolese','Trinidadian','Tobagan','Tunisian','Turkish','Turkoman','Tuvaluan','Ugandan','Ukrainian','Uruguayan','Uzbek','Vanuatuan','Venezuelan','Vietnamse','Western Samoan','Yemeni','Yugoslav','Zaïrean','Zambian','Zimbabwean','American'],
		passportissueplaceitems: ['United Kingdom','Albania','Algeria','Andorra','Angola','Antigua','Argentina','Armenia','Aruba','Australia','Austria','Azerbaijan','Bahamas','Bahrain','Bangladesh','Barbados','Belarus','Belgium','Belize','Bermuda','Bolivia','Bosnia','Botswana','Brazil','Brunei','Bulgaria','Cambodia','Cameroon','Canada','Cape Verde','Cayman Islands','Chile','China','Colombia','Cook Islands','Costa Rica','Croatia','Cuba','Cyprus','Czech Republic','Denmark','Dominican Republic','Dutch Antilles','Ecuador','Egypt','El Salvador','Estonia','Ethiopia','Faroe Islands','Fiji','Finland','France','French Polynesia','Gabon','Gambia','Georgia','Germany','Ghana','Gibraltar','Greece','Grenada','Guatemala','Honduras','Hong Kong','Hungary','Iceland','India','Indonesia','Iran','Ireland','Israel','Italy','Ivory Coast','Jamaica','Japan','Jordan','Kazakhstan','Kenya','Kosovo','Kuwait','Laos','Latvia','Lebanon','Libya','Liechtenstein','Lithuania','Luxembourg','Macedonia','Madagascar','Malawi','Malaysia','Maldives','Malta','Martinique','Mauritius','Mexico','Moldova','Mongolia','Montenegro','Morocco','Mozambique','Namibia','Nepal','Netherlands','New Caledonia','New Zealand','Nicaragua','Nigeria','Norway','Oman','Pakistan','Panama','Paraguay','Peru','Philippines','Poland','Portugal','Puerto Rico','Qatar','Romania','Russia','Rwanda','Saudi Arabia','Senegal','Serbia','Singapore','Slovakia','Slovenia','South Africa','South Korea','Spain','Sri Lanka','St Kitts and Nevis','St Lucia','Suriname','Swaziland','Sweden','Switzerland','Syria','Taiwan','Tanzania','Thailand','The Seychelles','Trinidad and Tobago','Tunisia','Turkey','Turkmenistan','Turks and Caicos','Uganda','Ukraine','United Arab Emirates','Uruguay','USA','Uzbekistan','Vanuatu','Venezuela','Vietnam','Wallis &amp; Futuna','Zambia','Zimbabwe'],
		genderitems:['Male','Female'],
		titleitems:['Mr','Mrs','Miss','Master'],
		bookingdata: {},
		apisdata: {},
		alert: false,
		confsupport: false,
		passupport: false,
		branddata: {},
		airportapis: {},
		
      }
    },
	
		created () {
		if (this.isAuthenticated) {
		this.buildBooking(JSON.parse(localStorage.getItem("brefcldata")));
		
		
		}
	},
	
	computed: {
      isAuthenticated () {
		//console.log(this.$store.getters.isAuthenticated);
        return this.$store.getters.isAuthenticated
      },
	  
	  bookingnumber () {
		  if (this.isAuthenticated) {
			return localStorage.getItem("brefcl")
		  } else {
			return null
		  }
		},
		
		passport_number (){
				var dob = [];
				for(var z=0;z<this.apisdata.length;z++)
				{
					var th = this.apisdata[z];
					dob[z+1]=th.PassportNumber;
				}
				return dob;
		},
		
		passport_issue_place (){
				var dob = [];
				for(var z=0;z<this.apisdata.length;z++)
				{
					var th = this.apisdata[z];
					dob[z+1]=th.PassportIssuingGeographyLevel1ID;
				}
				return dob;
		},		
		
		nationality (){
				var dob = [];
				for(var z=0;z<this.apisdata.length;z++)
				{
					var th = this.apisdata[z];
					dob[z+1]=th.NationalityID;
				}
				return dob;
		},		
		
		gender (){
				var dob = [];
				for(var z=0;z<this.apisdata.length;z++)
				{
					var th = this.apisdata[z];
					dob[z+1]=th.gender;
				}
				return dob;
		},
		
		   
		
		DateOfBirth (){
				var dob = [];
				for(var z=0;z<this.apisdata.length;z++)
				{
					var th = this.apisdata[z];
					dob[z+1]=this.reformatDaten(th.DateOfBirth);
				}
				return dob;
		},
				

		
		datepidd (){
				var dob = [];
				for(var z=0;z<this.apisdata.length;z++)
				{
					dob[z+1]= this.formatDate(this.datepid[z+1]);
				}
				return dob;
		},		
		datepedd (){
				var dob = [];
				for(var z=0;z<this.apisdata.length;z++)
				{
					dob[z+1]= this.formatDate(this.dateped[z+1]);
				}
				return dob;
		},		
		
		DateOfBirthdate (){
				var dob = [];
				for(var z=0;z<this.apisdata.length;z++)
				{
					dob[z+1]= this.formatDate(this.DateOfBirth_ch[z+1]);
					
				}
				return dob;
		},		
		
	
		
		datepeddis (){

				var dob = [];
				for(var z=0;z<this.apisdata.length;z++)
				{
					var th = this.apisdata[z];
					if(this.reformatDaten(th.PassportExpiryDate)=='01/01/0001' || this.reformatDaten(th.PassportExpiryDate)=='00/00/0000')
					{
					dob[z+1]=null;
					}
					else
					{
					dob[z+1]=this.reformatDaten(th.PassportExpiryDate);
					}
				}
				return dob;
		},			
		
		datepiddis (){

				var dob = [];
				//console.log("aa=="+this.apisdata);
				for(var z=0;z<this.apisdata.length;z++)
				{
					var th = this.apisdata[z];
					
					if(this.reformatDaten(th.PassportIssueDate)=='01/01/0001' || this.reformatDaten(th.PassportIssueDate)=='00/00/0000')
					{
					dob[z+1]=null;
					}
					else
					{
					dob[z+1]=this.reformatDaten(th.PassportIssueDate);
					}
				}
				//console.log(dob);
				return dob;
		},		

	
		error () {
		return this.$store.state.error
	  },
	  loading () {
		return this.$store.state.loading
	  }
	  
    },
	
	watch: {
  error (value) {
    if (value) {
      this.alert = true
    }
  },
  alert (value) {
    if (!value) {
      this.$store.commit('setError', null)
    }
  }
	  
},

	methods: {
    buildBooking (data) {
      this.bookingdata = data
	  //console.log(this.bookingdata.BookingID);
	  //console.log(this.apisdata);
    },
	
	SubmitAPIS () {
		var ers='';
		var gendercheck='';
		for(var j=1;j<this.gender.length;j++)
		{
			gendercheck=this.gender[j];
		}		
		var nationalitycheck='';
		for(var j=1;j<this.nationality.length;j++)
		{
			nationalitycheck=this.nationality[j];
		}
		var datepidcheck='';
		for(var j=1;j<this.datepid.length;j++)
		{
			datepidcheck=this.datepid[j];
		}
		var datepedcheck='';
		for(var j=1;j<this.dateped.length;j++)
		{
			datepedcheck=this.dateped[j];
		}
		var passport_issue_placecheck='';
		for(var j=1;j<this.passport_issue_place.length;j++)
		{
			passport_issue_placecheck=this.passport_issue_place[j];
		}		
		
		 
		if (gendercheck === null || nationalitycheck === null || datepidcheck === null || datepedcheck === null || passport_issue_placecheck === null) {
			this.$store.commit('setError', "Gender/Nationality/Passport Issue Date/Passport Expiry Date/Passport Issue Place Required");
			ers="E";
		}
	
		
		if(ers=="")
		{
		this.$store.dispatch('SubmitAPIS', { bookingreference: this.bookingnumber, dateped: this.dateped, datepid: this.datepid, gender: this.gender, nationality: this.nationality, passport_number: this.passport_number, passport_issue_place: this.passport_issue_place, DateOfBirth_ch: this.DateOfBirth_ch })
		this.passupport=false
		this.$swal('Success','Thank you for submitting your passport information.','success')
		
		}
	  },
	  
	  ResendConfirmation()
	  {
		this.$store.dispatch('ResendConfirmation', { bookingreference: this.bookingnumber })
		this.confsupport=false
		this.$swal('Success','A copy of your confirmation Email has been successfully sent to <br/><br/><strong>'+this.bookingdata.LeadCustomer.CustomerEmail+'</strong><br/><br/>If you do not receive a copy via email, please check your junk folder just in case. If you are still having trouble please <a href="/support">contact support</a>.','success')
	  }
	  ,
	  
	  reformatDate(s) {
  var b = s.split('T');
  var c = b[0];
  var d = c.split('-');
  return d[2]+"/"+d[1]+"/"+d[0];
	} ,
	reformatDaten(s) {
    var b = s.split(' ');
  var c = b[0];
  var d = c.split('-');
  return d[2]+"/"+d[1]+"/"+d[0];
  
	},
	
	formatDate (date) {
        if (!date) return null
        const [year, mon, day] = date.split('-');
        return `${day}/${mon}/${year}`;
      }
	
	
	  
  },
		mounted() {
		
		 axios.get("https://mmb.msa.airportdirecttravel.com/getapidetailsfromdb?bookingreference="+this.bookingnumber)
    .then(response => {this.apisdata = JSON.parse(response.request.response); })
	
		if(localStorage.getItem("branddata")===null)
		{
		axios.get("https://brands.msa.airportdirecttravel.com/getbrandfromcodeformmb?brand_code="+this.bookingdata.BrandCode)
    .then(response => {
		this.branddata = JSON.parse(response.request.response); 
		//console.log("NLS"+this.branddata);
		localStorage.setItem("branddata",JSON.stringify(this.branddata));
		})
		}
		else{
		this.branddata = JSON.parse(localStorage.getItem("branddata"));
		//console.log("LS"+this.branddata.brand.brand_logo);
		}
		

		axios.get("https://mmb.msa.airportdirecttravel.com/airportcoun?bookingreference="+this.bookingnumber)
		.then(response => {
		this.airportapis = JSON.parse(response.request.response); 
		//console.log(this.airportapis.success);
		})

	
		}

	
  }
</script>